/**
 * マークファイル登録
 *
 * @export RegistMarkFileVo
 * @class RegistMarkFileVo
 */
export class RegistMarkFileVo {
    constructor(
        public markCode: string,
        public markCodeBranch: string,
    ) {}
}
